import Button from './button';

export default class Accent extends Button {
  get buttonClass() {
    return 'ds-button--accent';
  }
}
